// libs
import { styled } from '@nykaa/ui-components';

export const TextContainer = styled.div`
  ${({ theme }) => `
        margin-top: ${theme.spacing.spacing20};
        color: ${theme.colors.textSecondary};
    `}
  ${({ theme }) => theme.typography.bodySmall};
`;
